import React from 'react';
import { makeStyles } from '@material-ui/styles';

import { Checkbox, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles(theme => ({}));

const EnhancedCheckbox = props => {
    const {
        className,
        marchandId,
        checked,
        handleListOfMerchant,
        disabled,
        noLoading,
        ...rest
    } = props;
    const [isChecked, setIsChecked] = React.useState(checked);
    const [isSelected, setIsSelected] = React.useState(false);

    const handleCheckbox = () => {
        !noLoading && setIsSelected(true);
        handleListOfMerchant(marchandId);

        if (noLoading) {
            setIsChecked(false);
        }
    };

    return (
        <div>
            {isSelected ? (
                <CircularProgress
                    style={{ marginTop: 9, marginRight: 9, marginLeft: 8 }}
                    size={25}
                />
            ) : (
                <Checkbox disabled={disabled} onChange={handleCheckbox} checked={isChecked} />
            )}
        </div>
    );
};

export default EnhancedCheckbox;
